const formatDecimalNumber = (
  num: number,
  options: {
    minimumFractionDigits?: number;
    maximumFractionDigits?: number;
  },
): string => {
  return Intl.NumberFormat('en-US', options).format(num);
};

export default formatDecimalNumber;
